export const MESES_CORTOS = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Set', 'Oct', 'Nov', 'Dic'];
export const MESES_LARGOS = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Setiembre', 'Octubre', 'Noviembre', 'Diciembre'];
export const CAMPOS_MES = ['m1', 'm2', 'm3', 'm4', 'm5', 'm6', 'm7', 'm8', 'm9', 'm10', 'm11', 'm12'];

/**
 * Las columnas de UN presupuesto (S2-03): los 12 meses o los 13 períodos de 4
 * semanas. El backend manda `meses` (m1..mN) y `periodos` (con su rótulo corto,
 * Ene… o P01…, su nombre y sus fechas); sin eso, los 12 meses de siempre.
 */
export const camposDe = (data) => (data?.meses?.length ? data.meses : CAMPOS_MES);
export const rotulosDe = (data) => (data?.periodos?.length ? data.periodos.map(p => p.corto || p.nombre) : MESES_CORTOS);
export const nombresDe = (data) => (data?.periodicidad === 'cuatro_semanas' && data?.periodos?.length
  ? data.periodos.map(p => `${p.nombre} (${p.desde.slice(8, 10)}/${p.desde.slice(5, 7)} al ${p.hasta.slice(8, 10)}/${p.hasta.slice(5, 7)})`)
  : MESES_LARGOS);
/** "mes" o "período", para los textos de la pantalla. */
export const unidadDe = (data) => (data?.periodicidad === 'cuatro_semanas' ? 'período' : 'mes');

const fmt2 = new Intl.NumberFormat('es-CR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const fmt0 = new Intl.NumberFormat('es-CR', { maximumFractionDigits: 0 });

const SIMBOLO = { USD: '$', CRC: '₡' };

/**
 * Monto en la moneda del presupuesto, siempre con su signo: $1 234,56 o ₡1 234,56,
 * negativos con − delante. Cero → el texto de `cero` (por omisión el cero con signo).
 */
export function dinero(n, { moneda = 'USD', cero, decimales = 2 } = {}) {
  const sim = SIMBOLO[moneda] || '';
  const v = Number(n) || 0;
  if (v === 0) return cero !== undefined && cero !== null ? cero : `${sim}0${decimales === 0 ? '' : ',00'}`;
  const s = (decimales === 0 ? fmt0 : fmt2).format(Math.abs(v));
  return (v < 0 ? '−' : '') + sim + s;
}
/** Igual que dinero() en dólares (lo usan las pantallas que solo manejan USD). */
export function usd(n, opciones = {}) {
  return dinero(n, { cero: '$0,00', ...opciones, moneda: 'USD' });
}
export function usdSigno(n) {
  const v = Number(n) || 0;
  return (v > 0 ? '+$' : v < 0 ? '−$' : '$') + fmt2.format(Math.abs(v));
}
export function crc(n) {
  const v = Number(n) || 0;
  return '₡' + fmt0.format(Math.round(v));
}
export function pct(n) {
  return (Number(n) * 100).toLocaleString('es-CR', { maximumFractionDigits: 2 }) + ' %';
}
/** Lo que se muestra en el editor de una celda: la fórmula con "=" o el número */
export function textoCelda(celda) {
  if (!celda) return '';
  if (celda.formula) return '=' + celda.formula;
  const v = Number(celda.valor) || 0;
  return v === 0 ? '' : String(Number.isInteger(v) ? v : Math.round(v * 100000) / 100000);
}
